import React from 'react';
import { Attachment, AttachmentContainer } from './styled';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg';
import { getFileIcon } from '../../utils/fileIcons';
import { IAttachment, IAttachmentUpload } from '../../types/attachments';
import { downloadFile } from '../../utils/attachments';
import color from '../../theme/color';
import useAppDispatch from '../../hooks/useAppDispatch';
import { getViewUrl } from '../../redux/attachments/service';

interface AttachmentItemProps {
    file: IAttachment | IAttachmentUpload;
    index: number;
    trimFilename?: boolean;
    getAttachmentUrl?: (
        file: IAttachment | IAttachmentUpload,
        index: number
    ) => Promise<void>;
    removeAttachment?: (id: number) => void;
}

const AttachmentItem: React.FC<AttachmentItemProps> = ({
    file,
    index,
    trimFilename = false,
    getAttachmentUrl,
    removeAttachment
}) => {
    const dispatch = useAppDispatch();
    const handleDownload = async (e: React.MouseEvent) => {
        e.stopPropagation();

        if (!file.fileId) {
            console.error('File ID is missing:', file);
            return;
        }

        try {
            const response = await dispatch(
                getViewUrl({ fileId: file.fileId })
            ).unwrap();
            const url = response.url;

            await downloadFile(url, file.name || 'download');
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };

    const fileName = file.name;

    if (!fileName) {
        return null;
    }

    if (!file.type) {
        return (
            <Attachment
                key={`attachment-${file.name}-${index}`}
                trim={trimFilename}
            >
                <span title={file.name}>{fileName}</span>
            </Attachment>
        );
    }

    return getAttachmentUrl ? (
        <Attachment
            key={`attachment-${file.name}-${index}`}
            onClick={() => getAttachmentUrl(file, index)}
            style={{ cursor: 'pointer' }}
            trim={trimFilename}
        >
            {getFileIcon(file.type)}
            <span title={file.name}>{fileName}</span>
            <AttachmentContainer
                onClick={handleDownload}
                style={{ marginLeft: 'auto' }}
            >
                <DownloadIcon
                    width={15}
                    height={15}
                    style={{ color: color.white }}
                />
            </AttachmentContainer>
            {removeAttachment && (
                <AttachmentContainer onClick={() => removeAttachment(file.id)}>
                    <CloseIcon
                        width={10}
                        height={10}
                        style={{ color: color.white }}
                    />
                </AttachmentContainer>
            )}
        </Attachment>
    ) : (
        <Attachment
            key={`attachment-${file.name}-${index}`}
            trim={trimFilename}
        >
            {getFileIcon(file.type)}
            <span title={file.name}>{fileName}</span>
            {removeAttachment && (
                <AttachmentContainer onClick={() => removeAttachment(file.id)}>
                    <CloseIcon
                        width={10}
                        height={10}
                        style={{ color: color.white }}
                    />
                </AttachmentContainer>
            )}
        </Attachment>
    );
};

export default AttachmentItem;
